import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { isMultiCity } from '@websky/core/src/SearchForm/store/segments/selectors';
import Button from '@websky/core/src/Button';
import css from './SearchFormDatepickerControls.css';
const SearchFormDatepickerControls = ({ outDate, returnDate, isDoneable, onDone, onClear, onClose }) => {
    const { t } = useTranslation('SearchFormDatepicker');
    const isMultyCity = useSelector(isMultiCity);
    const onClearHandler = useCallback(() => {
        if (!outDate && !returnDate) {
            onClose();
        }
        onClear();
    }, [onClear, onClose]);
    const onDoneHandler = useCallback(() => {
        if (isDoneable) {
            onDone();
        }
    }, [isDoneable, onDone]);
    return (React.createElement("div", { className: css.controls },
        React.createElement(Button, { variant: "flat", size: "small", className: cn(css.button, css.clear), onClick: onClearHandler }, t('Clear')),
        React.createElement(Button, { variant: "flat", size: "small", className: css.button, onClick: onDoneHandler }, outDate ? (returnDate || isMultyCity ? t('Done') : t('Without back date')) : t('Done'))));
};
export default SearchFormDatepickerControls;
